<script setup lang="ts">
import { DateTime } from 'luxon';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import TableColumn from 'primevue/column';

interface Props {
  fligtDetail: any[];
}
const props = defineProps<Props>();

const emits = defineEmits<{
  changeFlight: [];
  clearFlight: [];
}>();

const formatDate = (date, format) => {
  return date ? DateTime.fromISO(new Date(date).toISOString()).toFormat(format) : '';
};
</script>

<template>
  <div class="flight_class_detail">
    <DataTable :value="props.fligtDetail" class="p-datatable-gridlines w-full p-datatable-sm">
      <TableColumn field="flight" :header="$t('worksheet.flight_number')">
        <template #body="{ data, field }">
          {{ data[field] }}
        </template>
      </TableColumn>
      <TableColumn field="gate" :header="$t('worksheet.from')" class="w-3">
        <template #body="{ data, field }">
          {{ data[field] }}
        </template>
      </TableColumn>
      <TableColumn field="dest" :header="$t('worksheet.to')" class="w-3">
        <template #body="{ data, field }">
          {{ data[field] }}
        </template>
      </TableColumn>
      <TableColumn field="depDate" :header="$t('worksheet.dep_date')" class="w-2">
        <template #body="{ data, field }">
          {{ formatDate(data[field], 'dd-MMM-yyyy') }}
        </template>
      </TableColumn>
      <TableColumn field="depTime" :header="$t('worksheet.dep_time')">
        <template #body="{ data, field }">
          {{ data[field] }}
        </template>
      </TableColumn>
      <TableColumn field="arrivalDate" :header="$t('worksheet.arrival_date')" class="w-2">
        <template #body="{ data, field }">
          {{ formatDate(data[field], 'dd-MMM-yyyy') }}
        </template>
      </TableColumn>
      <TableColumn field="arrivalTime" :header="$t('worksheet.arrival_time')">
        <template #body="{ data, field }">
          {{ data[field] }}
        </template>
      </TableColumn>
    </DataTable>
    <div class="button_container mt-4 flex justify-content-end">
      <Button id="changeFlightBtn" :label="$t('management.cruise.change_flight')" class="uppercase button-submit mr-2 bg-primary border-noround" @click="emits('changeFlight')"></Button>
      <Button id="clearFlightbtn" :label="$t('management.cruise.clear_select_flight')" class="uppercase button-submit bg-primary border-noround" @click="emits('clearFlight')"></Button>
    </div>
  </div>
</template>
